import type { ReactNode } from 'react';

import ChevronRightIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-right';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import STYLES from './DescriptionItem.module.scss';

import { buildDetailsMapAttributes } from '@hotels-hotel-detail/utils/meaningful-behaviour-data/details-map';
import { MeaningfulBehaviourDataWrapper } from '@shared/ui/contexts/meaningful-behaviour-data';

type Props = {
  content: ReactNode;
  hotelId: string;
  descItemKey: string;
  Icon?: any;
  onClick?: () => void;
  type?: string;
};
const DescriptionItem = ({
  Icon,
  content,
  descItemKey,
  hotelId,
  onClick = () => {},
  type,
}: Props) => (
  <MeaningfulBehaviourDataWrapper
    {...buildDetailsMapAttributes({ hotelId, item: descItemKey })}
  >
    <div
      className={STYLES.DescriptionItem}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <div className={STYLES.DescriptionItem__contentContainer}>
        {Icon && (
          <Icon className={STYLES.DescriptionItem__icon} data-testid={type} />
        )}
        <BpkText
          textStyle={TEXT_STYLES.footnote}
          className={STYLES.DescriptionItem__content}
        >
          {content}
        </BpkText>
      </div>
      <ChevronRightIcon className={STYLES.DescriptionItem__rightIcon} />
    </div>
  </MeaningfulBehaviourDataWrapper>
);

export default DescriptionItem;
